<template>
  <div>
    <div class = 'ztjjBox'>
      <div class="ztjjcon">
        <div class="contitle">专题聚集</div>
        <div class="carouselbox">
          <!-- <el-carousel :interval="4000" type="card" height="120px">
            <el-carousel-item v-for="item in 6" :key="item">
              <h3 class="medium">{{ item }}</h3>
            </el-carousel-item>
          </el-carousel> -->
          <el-carousel indicator-position="outside" height="120px" trigger="click">
            <el-carousel-item v-for="(itemArr,i) in list1" :key="i">
              <div class = 'linkBox'>
                <div class = 'imgBoxLink' v-for="(item,index) in itemArr.arrkey" :key="index" @click="goBlank(item)">
                  <img class = 'imglink' :src="commonUrl + item.url" alt="">
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="tjjgswiper">
      <div class="tjjg_cont">
        <div class="tjjg_cont_list">
          <div class="title">
            <span class="span1">特别关注</span>
            <span v-if="list2 && list2.length>=8" @click="moreFn('特别关注',list21)" class="span2">更多</span>
          </div>
          <div class="box">
            <div class="opacity_box"></div>
            <ul class="clearfix">
              <li v-for="(item,index) in list2" :key="index" @click="goBlank(item)">{{item.configName}}</li>
            </ul>
          </div>
        </div>
        <div class="tjjg_cont_list">
          <div class="title">
            <span class="span1">技术机构</span>
            <span v-if="list3 && list3.length>=8" @click="moreFn('技术机构',list31)" class="span2">更多</span>
          </div>
          <div class="box">
            <div class="opacity_box"></div>
            <ul class="clearfix">
              <li v-for="(item,index) in list3" :key="index" @click="goBlank(item)">{{item.configName}}</li>
            </ul>
          </div>
        </div>
        <!-- <div class="ztjj_cont_list">
          <div class="opacity_box"></div>
          <div class="title">专题聚焦</div>
          <div class="zt_list">
            <ul>
              <li v-for="(item,index) in list1" :key="index" @click="goBlank(item)">
                  <img :src="commonUrl + item.url" alt="">
              </li>
            </ul>
          </div>
        </div> -->
      </div>
      <el-dialog
          :visible.sync="dialogVisible"
          width="70%"
          :before-close="handleClose">
          <div class="dialog_list">
              <div class="title">{{dialogName}}</div>
              <ul class="clearfix">
                  <li v-for="item in list4" :key="item" @click="goBlank(item)">{{item.configName}}</li>
                  <!-- <li v-for="item in list4" :key="item" @click="goBlank(item)">{{item.configName}}</li> -->
              </ul>
          </div>
      </el-dialog>
    </div>

    



</div>
</template>

<script>
export default {
  created() {},
  mounted() {
    
    for(let i = 0;i<3;i++){
        this.getggList(String(i));
    }
  },

  data() {
    return {
      dialogVisible: false,
      dialogName:'',
      list1: [],
      list2: [],
      list21: [],
      list31: [],
      list3: [],
      list4: [],
      query:{
            "configType": "",
            "pageInfo": {
                "pageNo": 1,
                "pageSize": 50
            },
      },
      commonUrl,
    };
  },

  methods: {
    goBlank(item){
        console.log(item)
        // this.$router.push({path:'charactQy'})
        if(item.openType && item.openType == '1'){
          if(item.linkUrl != "无" || item.linkUrl != ""){
            window.open(item.linkUrl,'_blank');
          }
        }else{
          if(item.linkUrl){
            window.location.href = item.linkUrl
            // this.$router.push({path:'charactQy'})
          }
        }
    },
    moreFn(name,arr) { // 更多
        this.dialogVisible = true;
        this.dialogName = name;
        this.list4 = arr;
    },
    handleClose(){
        this.dialogVisible = false;
    },
    getggList(i) {
      this.Axios({
        method: "post",
        url: Action.PROTAL_LSSPAGE,
        data: {
            ...this.query,
            configType:i  // 1 特别关注 2 技术机构 0 分站专题
        }
      })
        .then(res => {
          if (res.data.code === "000") {
            if(i =='0'){
                if(res.data.result.list.length>4){
                  let arr = []
                  let arr1 = []
                  arr = res.data.result.list.slice(0,4)
                  arr1 = res.data.result.list.slice(4,8)
                  this.list1.push({arrkey:arr})
                  this.list1.push({arrkey:arr1})
                }else{
                  this.list1.push({arrkey:res.data.result.list})
                }

            }else if(i =='1'){
                this.list2 = res.data.result.list.length >0 ? (res.data.result.list.length >8 ? res.data.result.list.splice(0,8) : res.data.result.list) : res.data.result.list;
                this.list21 = res.data.result.list;
              }else{
                this.list3 = res.data.result.list.length >0 ? (res.data.result.list.length >8 ? res.data.result.list.splice(0,8) : res.data.result.list) : res.data.result.list;
                this.list31 = res.data.result.list;
              }
            
          } else {
            this.$alert(res.data.msg || "系统错误...", "错误提示", {
              cofirmButtonText: "确定",
              type: "error"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleclickitem(id) {
      window.open(`${rootDomain}/newsDetails?id=${id}`);
    }
  }
};
</script>


<style lang="less" scoped>
.tjjgswiper li {
    list-style: none !important;
} 
.tjjgswiper {
  height: 386px;
  display: flex;
  justify-content: space-between;
  background: url("../../../../static/images/tbgz.png") 50% 50%;
  .tjjg_cont {
    width: 1180px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .tjjg_cont_list {
      width: 576px;
      margin-right: 28px;
      padding: 30px 0;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .span1 {
          font-family: PingFangSC-Medium;
          font-size: 28px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #ffffff;
        }
        .span2 {
          font-family: PingFangSC-Regular;
          text-decoration: underline;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #ffffff;
          cursor: pointer;
        }
      }
      .box {
        width: 576px;
        height: 257px;
        // background-color: #ffffff;
        // opacity: 0.16;
        margin-top: 20px;
        position: relative;
        .opacity_box {
          width: 576px;
          height: 257px;
          background-color: #ffffff;
          border-radius: 4px;
          opacity: 0.16;
          position: absolute;
          z-index:1
        }
        ul {
          padding: 10px 15px;
          width: 576px;
          height: 257px;
          overflow: hidden;
          z-index:999;
          position: relative;
          li {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 30px;
            letter-spacing: 0px;
            color: #ffffff;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
    .ztjj_cont_list {
      width: 352px;
      height: 386px;
      position: relative;

      .opacity_box {
        width: 352px;
        height: 386px;
        background-color: #e1ecfd;
        opacity: 0.31;
        position: absolute;
      }
      .title {
        font-family: PingFangSC-Medium;
        font-size: 28px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        padding: 30px 30px 0;
      }
      .zt_list {
        padding: 0 30px;
        ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-top: 10px;
          position: relative;
          overflow: auto;
          height:270px;
          li {
            width: 292px;
            height: 78px;
            background-color: #ffffff;
            margin-top: 10px;
            border-radius: 4px;
            cursor: pointer;
            img{
                width: 292px;
	            height: 78px;
                border-radius: 4px;
            }
          }
        }
      }
    }
  }
  /deep/.el-dialog__header{
    background: #fff !important;
    padding: 10px;
  }
  /deep/.el-dialog__headerbtn .el-dialog__close{
    color:#999 !important;
    font-size: 18px;
    font-weight: bolder;
  }
  .dialog_list{
    overflow-y: auto;

    .title{
        font-size: 32px;
        text-align: center;
    }
    ul {
        max-height: 500px;
        overflow-y: auto;
        margin-top: 20px;
        li{
            width: 49%;
            float: left;
            font-size: 16px;
            line-height: 40px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            margin-left: 1%;
        }
    }
  }
}
.ztjjBox{
  margin-top:30px;
  height: 273px;
  display: flex;
  justify-content: space-between;
  background: url("../../../../static/images/ztjj.png") no-repeat;
  background-size:100% 100%;
  .ztjjcon{
    width: 1180px;
    margin: 0 auto;
    height:273px;
    .contitle{
      height: 40px;
      font-family: PingFangSC-Semibold;
      font-size: 28px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #222222;
      margin: 50px auto 12px;
      width: 112px;
      font-weight:900;
    }
    .carouselbox{
      height:120px;
      .linkBox{
        display: flex;
        .imgBoxLink{
          width: 284px;
	        height: 120px;
          margin-right:10px;
          .imglink{
            display: block;
            width: 284px;
	          height: 120px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/homePage/compontents/tjjg.vue